import {Group, Loader, Text} from '@mantine/core';
import type {FC} from 'react';

/**
 * Centered loading indicator — a Mantine `Loader` with optional label text.
 * @registry Centered spinner with optional loading text, for section/page loading states.
 *
 * Ported from `library-m/feedback/Spinner`. Prop surface kept identical.
 */
export interface SpinnerProps {
  loadingText?: string;
}

export const Spinner: FC<SpinnerProps> = ({loadingText}) => {
  return (
    <Group mt="xl" justify="center">
      <Text>{loadingText}</Text>
      <Loader color="black" size="md" />
    </Group>
  );
};
